<template>
  <div class="analysis_BigBox" v-show="analysisVisible">
    <!-- 数据监控详情 -->
    <!-- <analysis-detais
      :analysisDetaisVisible="analysisDetaisVisible"
      :analysisDetaisObject="analysisDetaisObject"
      @analysisDetaisCloseClick="analysisDetaisCloseClick"
    ></analysis-detais> -->
    <!-- 标签部分 -->
    <div class="analysis">
      <h1>投前分析</h1>
      <img :src="close" alt="关闭" @click="analysisCloseClick()" />
      <div class="analysis_box">
        <span class="analysis_box_title">
          <span class="analysis_box_titleTop">
            <img :src="monitor" alt="监控检测报告" />
            <span>数据检测报告</span>
          </span>
          <span class="analysis_box_titleBottom"
            >（共{{ analysisData.monitor_num }}条）</span
          >
        </span>
        <span class="analysis_box_top">
          <img
            :src="analysisData.avatar"
            alt="analysisData.name"
            class="analysis_box_top_img"
          />
          <span class="analysis_box_top_content">
            <span>{{ analysisData.name }}</span>
            <span>{{ analysisData.wx }}</span>
          </span>
        </span>
        <span class="analysis_list">
          <span v-for="(item, index) in listTitile" :key="index">
            {{ item }}
          </span>
        </span>
        <span
          class="list_content"
          v-for="(analysisList, index) in analysisData.analysisList"
          :key="index"
        >
          <span>
            <span>{{ positionStatus(analysisList.position) }}</span>
            <span @click="goDetailMethod(analysisList.url)">{{ analysisList.title }}</span>
          </span>
          <span>{{ analysisList.pubtime }}</span>
          <span>{{ analysisList.start_ts }}</span>
          <span>{{ analysisList.day }}</span>
          <span>{{ analysisList.status }}</span>
          <span @click="analysisDetails(analysisList, index)"
            ><span>详情</span></span
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import analysisDetais from "@/components/searchPopup/analysis-details.vue";
let url = require("url");
export default {
  name: "analysisPopup",
  data() {
    return {
      close: require("@/common/assets/close.png"),
      monitor: require("@/common/assets/monitor.png"),
      analysisList: [],
      listTitile: [
        "文章标题",
        "发文时间",
        "监控创建时间",
        "监控周期",
        "监控结果",
        "操作",
      ],
      analysisDetaisVisible: false,
      analysisDetaisObject: {},
    };
  },
  watch: {
    analysisData(val) {
      this.analysisList = val.analysisList;
      // console.log(this.analysisList);
    },
  },
  props: {
    analysisVisible: {
      type: Boolean,
      default: false,
    },
    analysisData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    analysisDetais,
  },
  computed: {
    positionStatus() {
      return (position) => {
        switch (position) {
          case 1:
            return "头条";
          case 2:
            return "次条";
          case 3:
            return "三条";
          case 4:
            return "四条";
          case 5:
            return "五条";
          case 6:
            return "六条";
          case 7:
            return "七条";
          case 8:
            return "八条";
        }
      };
    },
  },
  methods: {
    goDetailMethod(url){
      window.open(url)
    },
    analysisDetaisCloseClick() {
      this.analysisDetaisVisible = !this.analysisDetaisVisible;
    },
    analysisCloseClick() {
      this.$emit("analysisCloseClick");
    },
    // f分析详情
    analysisDetails(item, index) {
      let urlDetais = this.$router.resolve({
        path: "/monitorView",
        query: {
          post: url.parse(item.postlink, true).query.post,
        },
      });
      window.open(urlDetais.href, "_blank");
      // this.analysisDetaisVisible = true;
      // this.$http.axiosFun(
      //   this.$api.monitor.read_praise,
      //   {
      //     post: url.parse(item.postlink, true).query.post,
      //     type: 1,
      //   },
      //   (res) => {
      //     this.$http.axiosFun(
      //       this.$api.monitor.read_praise_report,
      //       {
      //         post: url.parse(item.postlink, true).query.post,
      //       },
      //       (res1) => {
      //         this.analysisDetaisObject = {
      //           charts: res.data.charts,
      //           profile: res.data.profile,
      //           forecast_fake: res1.data.forecast_fake,
      //           forecast_fake_per: res1.data.forecast_fake_per,
      //           status: res1.data.status,
      //           post: url.parse(item.postlink, true).query.post,
      //         }
      //         console.log(this.analysisDetaisObject);
      //       }
      //     );
      //   }
      // );
    },
  },
};
</script>

<style lang="less" scoped>
.analysis_BigBox {
  width: 100%;
  height: 100%;
  background-color: rgba(29, 29, 29, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  .analysis {
    // width: 1200px;
    // // height: 1020px;
    // height: 90%;
    // background-color: #fff;
    // margin-left: calc(100% / 2 - 1200px / 2);
    // // margin-top: 60px;
    // margin-top: 2%;
    // position: fixed;
    // z-index: 1000;
    width: 1400px;
    // height: 1020px;
    height: 100%;
    background-color: #fff;
    margin-left: calc(100% / 2 - 1400px / 2);
    // margin-top: 2%;
    position: fixed;
  }
  .analysis > h1 {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    // border: solid 1px;
    font-size: 26px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    line-height: 90px;
    text-align: center;
    color: #000000;
  }
  .analysis > img {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .analysis_box {
    width: 100%;
    height: 84%;
    overflow-x: hidden;
    padding-top: 30px;
    box-sizing: border-box;
    border: solid 1px #ccc;
    border-bottom: none;
    border-right: none;
    border-left: none;
  }
  .analysis_box_title::after {
    content: "";
    clear: both;
    display: none;
  }
  .analysis_box_title {
    width: 100%;
    // border: solid 1px;
    display: inline-block;
    .analysis_box_titleTop {
      width: 100%;
      float: left;
      // border: solid 1px;
      height: 34px;
      display: inline-block;
      img {
        width: 24px;
        height: 24px;
        display: inline-block;
        margin-left: calc(100% / 2 - 80px);
        margin-top: calc(34px / 2 - 24px / 2);
        float: left;
      }
      span {
        float: left;
        font-size: 20px;
        font-weight: 600;
        line-height: 34px;
        margin-left: 6px;
      }
    }
    .analysis_box_titleBottom {
      float: left;
      width: 100%;
      // border: solid 1px;
      display: inline-block;
      font-size: 20px;
      height: 34px;
      line-height: 34px;
      text-align: center;
    }
  }
  .analysis_box_top {
    // border: solid 1px;
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    padding: 0 40px;
    margin-top: 10px;
    height: 80px;
    .analysis_box_top_img {
      float: left;
      width: 80px;
      height: 80px;
      box-sizing: border-box;
      border-radius: 100%;
      display: inline-block;
    }
    .analysis_box_top_content {
      box-sizing: border-box;
      width: calc(100% - 100px);
      margin-left: 20px;
      margin-top: 10px;
      display: inline-block;
      // border: solid 1px;
      span:first-child {
        display: inline-block;
        // border: solid 1px;
        box-sizing: border-box;
        width: 100%;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 600;
        color: #333333;
        line-height: 30px;
      }
      span:last-child {
        box-sizing: border-box;
        display: inline-block;
        // border: solid 1px;
        width: 100%;
        font-size: 18px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }
    }
  }
  .analysis_list {
    float: left;
    margin-top: 20px;
    box-sizing: border-box;
    height: 70px;
    background-color: #e5e5e5;
    // border: solid 1px;
    width: 100%;
    display: inline-block;
    span {
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 6);
      font-size: 20px;
      text-align: center;
      line-height: 70px;
    }
    span:first-child {
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 4);
      font-size: 20px;
    }
    span:nth-child(2) {
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 6);
      font-size: 20px;
    }
    span:nth-child(4),
    span:nth-child(5) {
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 8);
      font-size: 20px;
    }
  }
  .list_content {
    float: left;
    box-sizing: border-box;
    height: 70px;
    border: solid 1px #e5e5e5;
    border-top: none;
    text-align: center;
    line-height: 70px;
    width: 100%;
    display: inline-block;
    span {
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 6);
      /* 规定段落中的文本不进行换行： */
      white-space: nowrap;
      /* 内容会被修剪，并且其余内容是不可见的。 */
      overflow: hidden;
      /* 显示省略符号来代表被修剪的文本。 */
      text-overflow: ellipsis;
      font-size: 20px;
    }
    span:first-child {
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 4);
      font-size: 20px;
    }
    span:nth-child(2) {
      padding-left: 10px;
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 6);
      font-size: 20px;
    }
    span:nth-child(4),
    span:nth-child(5) {
      float: left;
      box-sizing: border-box;
      // border: solid 1px;
      display: inline-block;
      height: 70px;
      width: calc(100% / 8);
      font-size: 20px;
    }
    span:last-child {
      // border: solid 1px red;
      width: calc(100% / 6);
      cursor: pointer;
      display: inline-block;
      span {
        display: inline-block;
        width: 120px;
        text-align: center;
        line-height: 30px;
        height: 30px;
        margin-top: calc(70px / 2 - 30px / 2);
        margin-left: 40px;
        border-radius: 8px;
        background-color: #20a0ff;
        // margin-left: 10px;
        color: #fff;
        box-sizing: border-box;
        font-size: 16px;
      }
    }
  }
  .list_content > span:first-child > span:first-child {
    display: inline-block;
    width: 60px;
    text-align: center;
    line-height: 30px;
    height: 30px;
    margin-top: calc(70px / 2 - 30px / 2);
    border-radius: 8px;
    background-color: #ff8e20;
    margin-left: 10px;
    color: #fff;
    box-sizing: border-box;
    font-size: 16px;
  }
  .list_content > span:first-child > span:last-child {
    width: calc(100% - 60px - 10px);
    display: inline-block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/analysis-popup.vue